import { Currency } from "@sixty-six-north/i18n"
import { Cart } from "@commercetools/platform-sdk"
import {
  ShippingMethodKeys,
  shippingMethodToDurationText
} from "../checkout/shipping/ShippingMethods"
import { CartCalculator } from "../cart/CartCalculator"
import { amountByCurrencyForApplePay } from "../i18n/CurrencyFormatter"
import ApplePayLineItem = ApplePayJS.ApplePayLineItem
import ApplePayShippingMethod = ApplePayJS.ApplePayShippingMethod
import ApplePayShippingMethodSelectedEvent = ApplePayJS.ApplePayShippingMethodSelectedEvent

export const transformShippingMethodForApplePay = ({
  method,
  store,
  shippingRate,
  isFreeShipping,
  t
}): ApplePayShippingMethod => {
  const getShippingMethodDuration = shippingMethodToDurationText(t)
  return {
    label: method.name,
    identifier: method.id,
    detail: getShippingMethodDuration(
      method.key || ShippingMethodKeys.standardShipping
    ),
    amount:
      isFreeShipping || !shippingRate
        ? "0.00"
        : store.amountByCurrencyForApplePay(shippingRate.price)
  }
}

export const transformAppleEventToCartInfo = event => {
  const { shippingContact = {}, billingContact = {} } = event
  const transformApplePayAddressToCartFormat = address => {
    const {
      addressLines = [],
      locality: city,
      givenName: firstName,
      familyName: lastName,
      postalCode,
      countryCode: country,
      administrativeArea,
      phoneNumber: phone
    } = address
    return {
      firstName,
      lastName,
      streetName: addressLines[0],
      additionalStreetInfo: addressLines[1] || "",
      postalCode,
      state: country === "US" ? administrativeArea : undefined,
      region: country === "CA" ? administrativeArea : undefined,
      city,
      country,
      phone
    }
  }

  return {
    emailAddress: shippingContact.emailAddress,
    shippingAddress: transformApplePayAddressToCartFormat(shippingContact),
    billingAddress: transformApplePayAddressToCartFormat(billingContact)
  }
}

export const getCheckoutLineItems = (
  c: Cart | undefined,
  currency: Currency,
  showTaxes: boolean,
  t: (key: string) => string
) => {
  const discount = CartCalculator.totalDiscount(c)
  const subtotal = CartCalculator.subTotalOriginalPrice(c)
  const taxesAndDuties = CartCalculator.taxesCentAmount(c)
  const shipping = CartCalculator.shippingCostCentAmount(c)
  const transformAmountForApplePay = amountByCurrencyForApplePay(currency)
  const costs = [
    {
      label: t("subtotal"),
      amount: transformAmountForApplePay(subtotal)
    },
    {
      label: t("discount"),
      amount: transformAmountForApplePay(discount)
    },
    {
      label: t("shipping"),
      amount: transformAmountForApplePay(shipping)
    }
  ]

  if (showTaxes) {
    costs.push({
      label: t("taxesAndDuties"),
      amount: transformAmountForApplePay(taxesAndDuties)
    })
  }
  return costs
}
